/**
 * Face features: eyes & eyebrows
 */
import { EYE_TYPES } from '../../../items/item-types.js';

export { EYE_TYPES };

export function drawFaceEyesAndBrows(ctx, size, options = {}) {
  const expr = options.expression || 'happy';
  const isFemale = options.gender === 'female';
  const age = options.age || 'adult';
  const isChild = age === 'child';
  const isElder = age === 'elder';
  const isMature = isElder || age === 'senior';

  // 3. Mắt & Lông mày theo từng biểu cảm & Chủng tộc ngoài hành tinh
  const eyeY = size * 0.47;
  // Trẻ em mắt to tròn hơn, người già mắt híp nhỏ lại
  const eyeW = size * 0.14 * (isChild ? 1.08 : 1);
  const eyeH = size * 0.18 * (isChild ? 1.1 : isElder ? 0.85 : 1);
  const pupilColor = options.eyeColor || '#2c3e50';
  const browColor = options.eyebrowColor || (isElder ? '#8b8b8b' : '#4a3728');
  // Lông mày: nữ & trẻ em mảnh, đàn ông trung niên / cao tuổi rậm
  const browH = size * (isChild ? 0.028 : isFemale ? 0.026 : isMature ? 0.052 : 0.04);
  const eyeType = options.eyeType || 'normal';

  let eyeBox = null;

  if (eyeType === 'cyclops') {
    // 1 MẮT ĐỘC NHÃN KHỔNG LỒ PHÁT QUANG Ở TRUNG TÂM TRÁN
    const cX = size * 0.5;
    const cY = eyeY + size * 0.05;
    const eyeR = size * 0.22;

    // Vành hốc mắt sinh học / kim loại bên ngoài
    ctx.fillStyle = 'rgba(0, 0, 0, 0.4)';
    ctx.beginPath();
    ctx.arc(cX, cY, eyeR + size * 0.04, 0, Math.PI * 2);
    ctx.fill();

    // Củng mạc mắt (sclera)
    ctx.fillStyle = '#f8fafc';
    ctx.beginPath();
    ctx.arc(cX, cY, eyeR, 0, Math.PI * 2);
    ctx.fill();

    // Mống mắt phát quang rực rỡ
    ctx.fillStyle = pupilColor;
    ctx.beginPath();
    ctx.arc(cX, cY, eyeR * 0.65, 0, Math.PI * 2);
    ctx.fill();

    // Con ngươi đen sâu thẳm
    ctx.fillStyle = '#0f172a';
    ctx.beginPath();
    ctx.arc(cX, cY, eyeR * 0.35, 0, Math.PI * 2);
    ctx.fill();

    // Điểm catchlight phản quang công nghệ cao
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(cX - eyeR * 0.22, cY - eyeR * 0.22, eyeR * 0.18, 0, Math.PI * 2);
    ctx.fill();

    // Lông mày đơn vắt ngang trán trên mắt độc nhãn
    ctx.fillStyle = browColor;
    ctx.fillRect(size * 0.28, eyeY - size * 0.12, size * 0.44, browH);

    eyeBox = {
      type: 'cyclops',
      center: { x: cX, y: cY, r: eyeR }
    };
  } else if (eyeType === 'cyber_visor') {
    // MẮT KÍNH VISOR SCANNER CYBERPUNK
    const vY = eyeY - size * 0.02;
    const vH = size * 0.2;
    // Dải kính visor màu tối
    ctx.fillStyle = '#09090b';
    ctx.fillRect(size * 0.12, vY, size * 0.76, vH);
    // Dải laser neon phát sáng
    ctx.fillStyle = pupilColor;
    ctx.fillRect(size * 0.15, vY + size * 0.06, size * 0.7, size * 0.08);
    // Điểm quét laser di chuyển
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(size * 0.45, vY + size * 0.04, size * 0.12, size * 0.12);
    // Mạch điện tử trên má phải
    ctx.strokeStyle = pupilColor;
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(size * 0.75, vY + vH);
    ctx.lineTo(size * 0.85, vY + vH + size * 0.1);
    ctx.lineTo(size * 0.85, size * 0.9);
    ctx.stroke();

    eyeBox = {
      type: 'cyber_visor',
      box: { x: size * 0.12, y: vY, w: size * 0.76, h: vH }
    };
  } else if (eyeType === 'fire') {
    // MẮT RỰC LỬA DUNG NHAM
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.28 : size * 0.72;
      const grad = ctx.createRadialGradient(cx, eyeY + size * 0.08, 2, cx, eyeY + size * 0.08, size * 0.14);
      grad.addColorStop(0, '#ffffff');
      grad.addColorStop(0.3, '#fef08a');
      grad.addColorStop(0.7, '#f97316');
      grad.addColorStop(1, 'rgba(153, 27, 27, 0)');
      ctx.fillStyle = grad;
      ctx.beginPath();
      ctx.arc(cx, eyeY + size * 0.08, size * 0.14, 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.fillStyle = '#ea580c';
    ctx.fillRect(size * 0.18, eyeY - size * 0.06, size * 0.22, browH);
    ctx.fillRect(size * 0.6, eyeY - size * 0.06, size * 0.22, browH);

    eyeBox = {
      type: 'dual',
      left: { x: size * 0.28 - size * 0.12, y: eyeY, w: size * 0.24, h: size * 0.18 },
      right: { x: size * 0.72 - size * 0.12, y: eyeY, w: size * 0.24, h: size * 0.18 }
    };
  } else if (eyeType === 'void') {
    // MẮT HƯ KHÔNG ĐEN TÍM NEON
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.28 : size * 0.72;
      ctx.fillStyle = '#09090b';
      ctx.beginPath();
      ctx.arc(cx, eyeY + size * 0.08, size * 0.12, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#c084fc';
      ctx.beginPath();
      ctx.arc(cx, eyeY + size * 0.08, size * 0.06, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#ffffff';
      ctx.beginPath();
      ctx.arc(cx, eyeY + size * 0.08, size * 0.025, 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.fillStyle = browColor;
    ctx.fillRect(size * 0.18, eyeY - size * 0.06, size * 0.2, browH);
    ctx.fillRect(size * 0.62, eyeY - size * 0.06, size * 0.2, browH);

    eyeBox = {
      type: 'dual',
      left: { x: size * 0.28 - size * 0.11, y: eyeY, w: size * 0.22, h: size * 0.18 },
      right: { x: size * 0.72 - size * 0.11, y: eyeY, w: size * 0.22, h: size * 0.18 }
    };
  } else if (eyeType === 'star') {
    // MẮT HÌNH NGÔI SAO 4 CÁNH LẤP LÁNH
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.28 : size * 0.72;
      const cy = eyeY + size * 0.08;
      ctx.fillStyle = '#f8fafc';
      ctx.fillRect(cx - size * 0.1, cy - size * 0.08, size * 0.2, size * 0.16);

      ctx.fillStyle = pupilColor;
      ctx.beginPath();
      ctx.moveTo(cx, cy - size * 0.07);
      ctx.lineTo(cx + size * 0.025, cy - size * 0.025);
      ctx.lineTo(cx + size * 0.07, cy);
      ctx.lineTo(cx + size * 0.025, cy + size * 0.025);
      ctx.lineTo(cx, cy + size * 0.07);
      ctx.lineTo(cx - size * 0.025, cy + size * 0.025);
      ctx.lineTo(cx - size * 0.07, cy);
      ctx.lineTo(cx - size * 0.025, cy - size * 0.025);
      ctx.closePath();
      ctx.fill();
    });
    ctx.fillStyle = browColor;
    ctx.fillRect(size * 0.18, eyeY - size * 0.06, size * 0.2, browH);
    ctx.fillRect(size * 0.62, eyeY - size * 0.06, size * 0.2, browH);

    eyeBox = {
      type: 'dual',
      left: { x: size * 0.28 - size * 0.1, y: eyeY, w: size * 0.2, h: size * 0.16 },
      right: { x: size * 0.72 - size * 0.1, y: eyeY, w: size * 0.2, h: size * 0.16 }
    };
  } else if (expr === 'laugh') {
    // MẮT CƯỜI HÍP HÌNH VÒNG CUNG ^ ^
    ctx.strokeStyle = pupilColor;
    ctx.lineWidth = size * 0.035;
    ctx.lineCap = 'round';
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.28 : size * 0.72;
      ctx.beginPath();
      ctx.arc(cx, eyeY + size * 0.08, size * 0.09, Math.PI * 1.15, Math.PI * 1.85);
      ctx.stroke();
    });
    // Lông mày nhướng vui tươi
    ctx.fillStyle = browColor;
    ctx.fillRect(size * 0.18, eyeY - size * 0.08, size * 0.2, browH);
    ctx.fillRect(size * 0.62, eyeY - size * 0.08, size * 0.2, browH);
  } else if (expr === 'crying') {
    // MẮT KHÓC NHẮM CHẶT MẾU MÁO T_T
    ctx.strokeStyle = pupilColor;
    ctx.lineWidth = size * 0.038;
    ctx.lineCap = 'round';
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.28 : size * 0.72;
      // Vòng cung ngược nhắm tịt mắt vì khóc
      ctx.beginPath();
      ctx.arc(cx, eyeY + size * 0.09, size * 0.08, Math.PI * 0.15, Math.PI * 0.85);
      ctx.stroke();
    });
    // Lông mày chữ Bát (\ /) mếu máo
    ctx.fillStyle = browColor;
    ctx.beginPath();
    ctx.moveTo(size * 0.19, eyeY - size * 0.01);
    ctx.lineTo(size * 0.38, eyeY - size * 0.09);
    ctx.lineTo(size * 0.38, eyeY - size * 0.05);
    ctx.lineTo(size * 0.19, eyeY + size * 0.03);
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(size * 0.81, eyeY - size * 0.01);
    ctx.lineTo(size * 0.62, eyeY - size * 0.09);
    ctx.lineTo(size * 0.62, eyeY - size * 0.05);
    ctx.lineTo(size * 0.81, eyeY + size * 0.03);
    ctx.fill();
  } else if (expr === 'dizzy') {
    // MẮT CHOÁNG VÁNG CHỮ X_X
    ctx.strokeStyle = '#0284c7';
    ctx.lineWidth = size * 0.04;
    ctx.lineCap = 'round';
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.28 : size * 0.72;
      const cy = eyeY + size * 0.07;
      const r = size * 0.07;
      ctx.beginPath();
      ctx.moveTo(cx - r, cy - r);
      ctx.lineTo(cx + r, cy + r);
      ctx.moveTo(cx + r, cy - r);
      ctx.lineTo(cx - r, cy + r);
      ctx.stroke();
    });
    // Lông mày xoắn vặn
    ctx.fillStyle = browColor;
    ctx.fillRect(size * 0.19, eyeY - size * 0.06, size * 0.18, browH);
    ctx.fillRect(size * 0.63, eyeY - size * 0.06, size * 0.18, browH);
  } else if (expr === 'wink') {
    // MẮT TRÁI MỞ TO, MẮT PHẢI NHÁY >
    // Mắt trái mở
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(size * 0.22, eyeY, eyeW, eyeH);
    ctx.fillStyle = pupilColor;
    ctx.fillRect(size * 0.24, eyeY + size * 0.03, size * 0.09, size * 0.13);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(size * 0.25, eyeY + size * 0.04, size * 0.04, size * 0.04);
    // Mắt phải nháy nhắm
    ctx.strokeStyle = pupilColor;
    ctx.lineWidth = size * 0.035;
    ctx.beginPath();
    ctx.arc(size * 0.72, eyeY + size * 0.08, size * 0.09, Math.PI * 1.15, Math.PI * 1.85);
    ctx.stroke();

    ctx.fillStyle = browColor;
    ctx.fillRect(size * 0.2, eyeY - size * 0.08, size * 0.18, browH);
    ctx.fillRect(size * 0.62, eyeY - size * 0.05, size * 0.18, browH);

    eyeBox = {
      type: 'dual',
      left: { x: size * 0.22, y: eyeY, w: eyeW, h: eyeH },
      right: { x: size * 0.63, y: eyeY, w: size * 0.18, h: size * 0.16 }
    };
  } else {
    // CÁC KIỂU MẮT CƠ BẢN CÓ ĐỒNG TỬ (happy, neutral, talking, yelling, surprise, scared, angry...)
    const isSurprise = expr === 'surprise';
    const isScared = expr === 'scared';
    const isAngry = expr === 'angry' || expr === 'yelling';
    const isEmbarrassed = expr === 'embarrassed';
    const isNeutral = expr === 'neutral';

    const ew = isSurprise ? eyeW * 1.15 : expr === 'yelling' ? eyeW * 1.1 : eyeW;
    const eh = isSurprise ? eyeH * 1.15 : isAngry && expr !== 'yelling' ? eyeH * 0.75 : eyeH;
    const curEyeY = isAngry && expr !== 'yelling' ? eyeY + size * 0.03 : eyeY;

    // Tròng trắng
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(size * 0.22, curEyeY, ew, eh);
    ctx.fillRect(size * 0.64, curEyeY, ew, eh);

    // Con ngươi
    ctx.fillStyle = pupilColor;
    const pw = isSurprise || isScared ? size * 0.065 : isNeutral ? size * 0.085 : size * 0.09;
    const ph = isSurprise || isScared ? size * 0.065 : isAngry && expr !== 'yelling' ? eh * 0.8 : size * 0.13;
    const pOffsetY = isEmbarrassed ? eh - ph : curEyeY - eyeY + size * 0.03;

    ctx.fillRect(size * 0.24 + (ew - pw) * 0.35, curEyeY + pOffsetY, pw, ph);
    ctx.fillRect(size * 0.66 + (ew - pw) * 0.35, curEyeY + pOffsetY, pw, ph);

    // Catchlight
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(size * 0.25 + (ew - pw) * 0.35, curEyeY + pOffsetY + size * 0.015, size * 0.035, size * 0.035);
    ctx.fillRect(size * 0.67 + (ew - pw) * 0.35, curEyeY + pOffsetY + size * 0.015, size * 0.035, size * 0.035);

    // Lông mày
    ctx.fillStyle = browColor;
    if (isAngry) {
      // Lông mày chữ V tức giận hoặc la hét
      ctx.beginPath();
      ctx.moveTo(size * 0.18, eyeY - size * 0.04);
      ctx.lineTo(size * 0.38, eyeY + size * 0.01);
      ctx.lineTo(size * 0.38, eyeY - size * 0.03);
      ctx.lineTo(size * 0.18, eyeY - size * 0.08);
      ctx.fill();

      ctx.beginPath();
      ctx.moveTo(size * 0.82, eyeY - size * 0.04);
      ctx.lineTo(size * 0.62, eyeY + size * 0.01);
      ctx.lineTo(size * 0.62, eyeY - size * 0.03);
      ctx.lineTo(size * 0.82, eyeY - size * 0.08);
      ctx.fill();
    } else if (expr === 'sad') {
      // Lông mày chữ Bát (vát chéo ngược \ /)
      ctx.beginPath();
      ctx.moveTo(size * 0.2, eyeY - size * 0.01);
      ctx.lineTo(size * 0.38, eyeY - size * 0.08);
      ctx.lineTo(size * 0.38, eyeY - size * 0.05);
      ctx.lineTo(size * 0.2, eyeY + size * 0.02);
      ctx.fill();

      ctx.beginPath();
      ctx.moveTo(size * 0.8, eyeY - size * 0.01);
      ctx.lineTo(size * 0.62, eyeY - size * 0.08);
      ctx.lineTo(size * 0.62, eyeY - size * 0.05);
      ctx.lineTo(size * 0.8, eyeY + size * 0.02);
      ctx.fill();
    } else if (isSurprise) {
      // Lông mày nhướng cao ngạc nhiên
      ctx.fillRect(size * 0.19, eyeY - size * 0.11, size * 0.19, browH);
      ctx.fillRect(size * 0.63, eyeY - size * 0.11, size * 0.19, browH);
    } else {
      // Lông mày bình thường / trung tính
      ctx.fillRect(size * 0.2, eyeY - size * 0.07, size * 0.18, browH);
      ctx.fillRect(size * 0.62, eyeY - size * 0.07, size * 0.18, browH);
    }

    eyeBox = {
      type: 'dual',
      left: { x: size * 0.22, y: curEyeY, w: ew, h: eh },
      right: { x: size * 0.64, y: curEyeY, w: ew, h: eh }
    };
  }

  return eyeBox;
}
